$(function () {
    'use strict';

    $(document).ready(function () {
        $('.a-create-compte-digiposte').click(function() {
            setTimeout(function() {
                window.location = '/coffre_fort/etape2';
            }, 1000);
        });
    });
});
